import { render, staticRenderFns } from "./Transporter.vue?vue&type=template&id=36e10dcc"
import script from "./Transporter.vue?vue&type=script&lang=ts"
export * from "./Transporter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports